import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import TxtRow from "components/Custom/TxtRow";
import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { ApiMasters } from "apihandlers//masters/masters";
import { ApiGeography } from "apihandlers/geography";
import { ApiLogin } from "apihandlers/login";
import { NOTIFY, DEFAULTS } from "common/config";
import { COLORS } from "common/colors";
import { COMMON_JS } from "common/scripts";
import {
  WARNINGS,
  SUCCESS,
  LABELS,
  ERRORS,
  TITLES,
  SUB_TITLES,
} from "common/labels";

const ApiMastersHandler = new ApiMasters();
const ApiGeographyHandler = new ApiGeography();
const ApiLoginHandler = new ApiLogin();

const Loading = (props: any) => {
  const { setDashMenu } = props;
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);

  const [users, setUsers] = useState([]);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [region, setRegion] = useState<any>({});
  const [eventUsers, setEventUsers] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const regionTypeRef: any = useRef(null);
  const usersRef: any = useRef(null);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "areaName",
      name: LABELS.NAME,
      type: "text",
      width: "26%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "geoFenceId",
      name: LABELS.GEO_FENCE_ID,
      type: "number",
      width: "18%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "contactNo",
      name: LABELS.CONTACT_NUMBER,
      type: "number",
      width: "18%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "loadingOnlyStatus",
      name: LABELS.LOADING_STATUS,
      width: "13%",
      editable: false,
      sortable: true,
      searchable: true,
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      align: "center",
    },
    {
      key: "activeStatusText",
      name: LABELS.ACTIVE_STATUS,
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      width: "15%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getUsers();
    }
  }, [loading]);

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    ApiLoginHandler.getUserProfile(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.userName,
          };
        });
        setUsers(list);
        getRegions();
      }
    });
  };

  const getRegions = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      loadingOnlyStatus: true,
    };
    ApiGeographyHandler.getRegions(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.regionName,
          };
        });
        setRegion(list);
        getRows();
      }
    });
  };

  const getRows = () => {
    const args = {
      // activeStatus: true,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      loadingOnlyStatus: true,
      loadingBayStatus: false,
      parkingLot: false,
    };
    ApiGeographyHandler.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
          if (list[i]["loadingOnlyStatus"]) {
            list[i]["loadingOnlyStatus"] = "Yes";
          } else {
            list[i]["loadingOnlyStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };

  const getEventUsers = (areaId) => {
    const args = {
      activeStatus: true,
      areaId,
    };
    ApiGeographyHandler.getEventUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.eventUsers;
        setEventUsers(users.filter((u) => list.indexOf(u.id) > -1));
      }
    });
  };

  const onEditRow = (row: any) => {
    setEventUsers(null);
    setManageDialog(true);
    setSelectedRow(row);
    getEventUsers(row.id);
  };

  const manageRecord = () => {
    const areaName = (
      document.getElementById("areaName") as HTMLInputElement
    ).value.trim();
    const geoFenceId = (
      document.getElementById("geoFenceId") as HTMLInputElement
    ).value.trim();
    const regionId = regionTypeRef.current.selectedValue.id;
    const distanceInKm = (
      document.getElementById("distanceInKm") as HTMLInputElement
    ).value.trim();
    const tatInHours = (
      document.getElementById("tatInHours") as HTMLInputElement
    ).value.trim();
    const alertKm = (
      document.getElementById("alertKm") as HTMLInputElement
    ).value.trim();
    const loadTime = (
      document.getElementById("loadTime") as HTMLInputElement
    ).value.trim();
    const address = (
      document.getElementById("address") as HTMLInputElement
    ).value.trim();
    const contactName = (
      document.getElementById("contactName") as HTMLInputElement
    ).value.trim();
    const contactNo = (
      document.getElementById("contactNo") as HTMLInputElement
    ).value.trim();
    let ele = document.querySelector(
      'input[name="loadingOnlyStatus"]:checked'
    ) as HTMLInputElement;
    const loadingOnlyStatus = ele ? ele.value : "";

    let active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = active ? active.value : "";
    const evenUsers = usersRef.current.selectedValue.map((u) => u.id);

    // Validations

    let errors = [];
    if (areaName == "") {
      errors.push({
        id: "areaName",
        msg:
          "<span class='bold'>" +
          LABELS.NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!regionId) {
      errors.push({
        id: "regionId",
        msg:
          "<span class='bold'>" +
          LABELS.REGION +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (geoFenceId == "") {
      errors.push({
        id: "geoFenceId",
        msg:
          "<span class='bold'>" +
          LABELS.GEO_FENCE_ID +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (distanceInKm == "") {
      errors.push({
        id: "distanceInKm",
        msg:
          "<span class='bold'>" +
          LABELS.DISTANCE_IN_KM +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (tatInHours == "") {
      errors.push({
        id: "tatInHours",
        msg:
          "<span class='bold'>" +
          LABELS.TAT_IN_HOURS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (alertKm == "") {
      errors.push({
        id: "alertKm",
        msg:
          "<span class='bold'>" +
          LABELS.ALERT_IN_KM +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (loadTime == "") {
      errors.push({
        id: "loadTime",
        msg:
          "<span class='bold'>" +
          LABELS.LOAD_TIME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      areaName,
      regionId,
      geofenceId: geoFenceId,
      distanceInKm,
      tatInHours,
      alertKm,
      loadingOnlyStatus,
      loadingBay: "false",
      parkingLot: "false",
      unloadingOnlyStatus: selectedRow.unloadingOnlyStatus
        ? selectedRow.unloadingOnlyStatus
        : "false",
      activeStatus: activeStatus.toString(),
      evenUsers,
      address,
      contactName,
      contactNo,
      loadTime,
    };
    console.log("Args ", args);
    setIsSubmit(true);
    ApiGeographyHandler.manageArea(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow: ", selectedRow, eventUsers);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.LOADING_POINTS}</li>
        </ul>
        <h4>{TITLES.LOADING_POINTS}</h4>
        <p className="SubTitles">{SUB_TITLES.LOADING_POINTS}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.LOADING_POINTS}
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.LOADING_POINTS}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.LOADING_POINTS + ": " + selectedRow.areaName
              : "Add " + TITLES.LOADING_POINTS
          }
          open={true}
          size={"lg"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="flexColumn">
            <div className="flexRowJustify">
              <div className="formGroup width30 red">
                <TxtRow
                  id={"areaName"}
                  label={LABELS.NAME}
                  required={true}
                  defaultValue={selectedRow.areaName}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup width30 red">
                <label>
                  {LABELS.REGION}
                  {<span className="red">{" *"}</span>}
                </label>

                <AutoComplete
                  list={region}
                  childRef={regionTypeRef}
                  defaultValue={
                    selectedRow.id
                      ? {
                          id: selectedRow.regionId,
                          label: selectedRow.regionName,
                        }
                      : null
                  }
                  disabled={isSubmit}
                />
              </div>

              <div className="formGroup width30 red">
                <TxtRow
                  id={"geoFenceId"}
                  label={LABELS.GEO_FENCE_ID}
                  defaultValue={
                    selectedRow.id ? selectedRow.geoFenceId.toString() : ""
                  }
                  required={true}
                  type={"number"}
                  disabled={isSubmit}
                />
              </div>
            </div>

            <div className="flexRowJustify">
              <div className="formGroup width30 red">
                <TxtRow
                  id={"distanceInKm"}
                  label={LABELS.DISTANCE_IN_KM}
                  defaultValue={
                    selectedRow.id ? selectedRow.distanceKM.toString() : ""
                  }
                  type={"number"}
                  required={true}
                  disabled={isSubmit}
                />
              </div>

              <div className="formGroup width30 red">
                <TxtRow
                  id={"tatInHours"}
                  label={LABELS.TAT_IN_HOURS}
                  defaultValue={
                    selectedRow.id
                      ? Number(selectedRow.tatHours).toString()
                      : selectedRow.tatHours
                  }
                  type={"number"}
                  required={true}
                  disabled={isSubmit}
                />
              </div>

              <div className="formGroup width30 red">
                <TxtRow
                  id={"alertKm"}
                  label={LABELS.ALERT_IN_KM}
                  defaultValue={selectedRow.alertKM}
                  type={"number"}
                  required={true}
                  disabled={isSubmit}
                />
              </div>
            </div>

            <div className="flexRowJustify ">
              <div className="formGroup width30 red">
                <TxtRow
                  id={"loadTime"}
                  label={LABELS.LOAD_TIME}
                  defaultValue={selectedRow.loadingTime}
                  type={"number"}
                  required={true}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup width30">
                <TxtRow
                  id={"address"}
                  label={LABELS.ADDRESS}
                  defaultValue={selectedRow.address}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup width30">
                <TxtRow
                  id={"contactName"}
                  label={LABELS.CONTACT_PERSON}
                  defaultValue={selectedRow.contactName}
                  disabled={isSubmit}
                />
              </div>
            </div>

            <div className="flexRowJustify">
              <div className="formGroup width30">
                <TxtRow
                  id={"contactNo"}
                  label={LABELS.CONTACT_MOBILE}
                  defaultValue={selectedRow.contactNo}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup width30">
                <label>{LABELS.LOADING_POINTS_ONLY}</label>
                <RadioBtn
                  list={[
                    {
                      id: "loadingPointYes",
                      value: "true",
                      label: LABELS.YES,
                      checked: selectedRow.id
                        ? selectedRow.loadingOnlyStatus === "Yes"
                        : true,
                      disabled: false,
                    },
                    {
                      id: "loadingPointNo",
                      value: "false",
                      label: LABELS.NO,
                      checked: selectedRow.id
                        ? selectedRow.loadingOnlyStatus === "No"
                        : false,
                      disabled: false,
                    },
                  ]}
                  row={true}
                  name={"loadingOnlyStatus"}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup width30">
                <label>{LABELS.NOTIFICATION_SUBSCRIPTION}</label>
                {eventUsers && (
                  <AutoComplete
                    list={users}
                    childRef={usersRef}
                    multiple={true}
                    defaultValue={selectedRow.id ? eventUsers : []}
                    disabled={isSubmit}
                    limit={3}
                  />
                )}
              </div>
            </div>
            <div className="flexRowJustify">
              <div className="formGroup width30">
                <label>{LABELS.ACTIVE + " " + LABELS.STATUS}</label>
                <RadioBtn
                  list={[
                    {
                      id: "activeYes",
                      value: "true",
                      label: LABELS.ACTIVE,
                      checked: selectedRow.id
                        ? selectedRow.activeStatus === true
                        : true,
                      disabled: false,
                    },
                    {
                      id: "activeNo",
                      value: "false",
                      label: LABELS.INACTIVE,
                      checked: selectedRow.id
                        ? selectedRow.activeStatus === false
                        : false,
                      disabled: false,
                    },
                  ]}
                  row={true}
                  name={"activeStatus"}
                  disabled={isSubmit}
                />
              </div>
            </div>
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className=" flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
                // loading={isSubmit}
              />
              <Btn
                text={LABELS.SAVE}
                onClick={manageRecord}
                loading={isSubmit}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Loading);
